import AllComp from "./components/AllComp";
import Banner from "./Home/Banner";
import Best from "./Home/Best";
import Contact1 from "./Home/Contact1";
import Contact2 from "./Home/Contact2";
import Feature from "./Home/Feature";
import Footer from "./Home/Footer";
import Fun from "./Home/Fun";
import Properties from "./Home/Properties";
import Video1 from "./Home/Video1";
import Video2 from "./Home/Video2";

function App() {
  
  return (
    <div >
    <AllComp/>;
    <Banner/>;
    <Feature/>;
    <Video1/>;
    <Video2/>;
    <Fun/>;
    <Best/>;
    <Properties/>;
    <Contact1/>;
    <Contact2/>;
    <Footer/>;
    </div>
  );
}

export default App;
